import React, { useEffect, useMemo, useState } from 'react'
import { FormHelperText, TextField, Autocomplete, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

export default function AutoCompleteSelect(props) {
    const {
        name,
        label,
        value,
        error = null,
        onChange,
        options = [],
        labelKey,
        valueKey,
        isRequired = false,
        isDisabled = false,
        disableSorting = false,
        hideTitle = false,
        useDeleteOption = false,
        onDelete = () => {}
    } = props

    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (options && labelKey && !disableSorting) {
            options.sort((a, b) => (a[labelKey] || '').localeCompare(b[labelKey] || ''))
        }
    }, [options, labelKey, disableSorting])

    const filteredOptions = useMemo(() => {
        const search = inputValue.trim().toLowerCase()
        if (!search) return options

        return options.filter((o) => o[labelKey]?.toLowerCase().startsWith(search))
    }, [inputValue, options, labelKey])

    return (
        <div style={{ width: '100%' }}>
            {!hideTitle && (
                <div style={{ fontSize: '12px', marginBottom: '6px' }}>
                    {label} {isRequired && <b style={{ color: 'red' }}>*</b>}
                </div>
            )}

            <Autocomplete
                value={options.find((o) => o[valueKey] === value) || null}
                inputValue={inputValue}
                onInputChange={(e, newValue) => setInputValue(newValue)}
                options={filteredOptions}
                filterOptions={(x) => x}
                disabled={isDisabled}
                size="small"
                getOptionLabel={(option) => option[labelKey] || ''}
                isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]}
                onChange={(event, newValue) => {
                    onChange({
                        target: {
                            name,
                            value: newValue ? newValue[valueKey] : ''
                        }
                    })
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }} key={option[valueKey]}>
                        {option[labelKey]}
                        {useDeleteOption && (
                            <IconButton
                                size="small"
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(option[valueKey])
                                }}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        )}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField {...params} error={!!error} helperText={error} variant="outlined" />
                )}
            />

            {error && <FormHelperText error>{error}</FormHelperText>}
        </div>
    )
}
